import React from 'react';
import FormikUserForm from './components/Form'
import './App.css';

function App() {
  return (
    <div className="App">
      <FormikUserForm/>
    </div>
  );
}

export default App;
